import { useQuery } from '@tanstack/react-query';

import { artiaProtectedApi } from '@/lib/api-client';
import { UtilizationType } from '../types/market-share';

const getUtilizationTypes = (): Promise<UtilizationType[]> => {
  return artiaProtectedApi.get('market-share/utilization-types');
};

export const makeUtilizationTypesQueryKey = () => ['market-share', 'utilization-types'];

export const useUtilizationTypes = () => {
  return useQuery({
    queryKey: makeUtilizationTypesQueryKey(),
    queryFn: getUtilizationTypes,
  });
};
